export default function useNewFetchHeaders(
    product: MaybeRef<string | null> = null,
    team: MaybeRef<string | null> = null,
) {
    const { session, loggedIn } = useUserSession();

    const accessToken = computed(() => {
        if (!session.value?.accessToken || !loggedIn.value) {
            return null;
        }

        const token = session.value?.accessToken;

        return token.startsWith('Bearer ') ? token : `Bearer ${token}`;
    });

    // Request Context
    const { urlParams } = useAdminUrl();
    // const { currentProductUuid } = storeToRefs(useProductStore());
    // const { currentTeamUuid } = storeToRefs(useTeamsStore());

    const productHeader = computed(
        () => unref(product) ?? urlParams.value?.product,
        // ?? currentProductUuid.value,
    );

    const teamHeader = computed(
        () => unref(team) ?? urlParams.value?.team, // ?? currentTeamUuid?.value,
    );

    // The request context is a combination of team and product headers.
    const requestContext = computed(() => {
        if (!productHeader.value && !teamHeader.value) {
            return 'member';
        }

        return `${teamHeader.value}:${productHeader.value}`;
    });

    const reqHeaders = computed<Record<string, string>>(() => {
        const h: Record<string, string> = {};

        if (productHeader.value) {
            h['X-Context-Product'] = productHeader.value;
        }
        if (teamHeader.value) {
            h['X-Context-Team'] = teamHeader.value;
        }
        if (accessToken.value) {
            h.Authorization = accessToken.value;
        }

        return h;
    });

    return {
        reqHeaders,
        // Computed properties for headers
        requestContext,
        productHeader,
        teamHeader,
    };
}
